import React from "react";
import { useHistory, useLocation } from "react-router-dom";
import { Box, CircularProgress } from "@material-ui/core";
import SetlistTemplatesPage from "./SetlistTemplatesPage";
import templatesAPI from "restApi/templatesApi";

export default () => {
  const history = useHistory();
  const location = useLocation();
  const [templates, setTemplates] = React.useState([]);
  const [loading, setLoading] = React.useState(true);
  // A real template's id, "new" for a not-yet-saved draft, or null for
  // nothing selected.
  const [selectedId, setSelectedId] = React.useState(null);

  const loadTemplates = () =>
    templatesAPI.getTemplates().then((res) => {
      setTemplates(res.data || []);
      setLoading(false);
    });

  React.useEffect(() => {
    loadTemplates();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSelect = (id) => setSelectedId(id);
  const handleCreateNew = () => setSelectedId("new");

  const handleSave = (draft) => {
    const request = draft.id
      ? templatesAPI.patchTemplate(draft.id, { name: draft.name, sections: draft.sections })
      : templatesAPI.createTemplate({ name: draft.name, sections: draft.sections });
    return request.then((res) => {
      loadTemplates();
      setSelectedId(res.data.id);
    });
  };

  const handleDelete = (id) =>
    templatesAPI.deleteTemplate(id).then(() => {
      setSelectedId(null);
      loadTemplates();
    });

  const handleSetDefault = (id) =>
    templatesAPI.setDefault(id).then(() => loadTemplates());

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" mt={8}>
        <CircularProgress color="secondary" />
      </Box>
    );
  }

  return (
    <SetlistTemplatesPage
      templates={templates}
      selectedId={selectedId}
      onSelect={handleSelect}
      onCreateNew={handleCreateNew}
      onSave={handleSave}
      onDelete={handleDelete}
      onSetDefault={handleSetDefault}
      onBack={() => history.push((location.state && location.state.from) || "/admin")}
    />
  );
};
